<template>
    <div :style="'width:'+width">
        <v-select :id="`div_`+name"
                  v-model="model_id"
                  :filterable="false"
                  :name="`div_`+name"
                  :options="modelOptions"
                  :reduce="option => type === 'int' ? parseInt(option.id) : type === 'text'? option.id.toString(): option.id"
                  class="style-chooser flex-grow-1"
                  label="label"
                  placeholder=""
                  @search="onSearch">
        </v-select>
        <input :id="name" v-model="model_id" :name="name" type="hidden">
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';

export default {
    name: "SelectDataComponent",
    components: {vSelect},
    props: {
        initialValue: {
            required: false,
            default: null,
        },
        table: {
            required: true
        },
        fieldName: {
            required: true
        },
        fieldId: {
            required: true
        },
        joins: {
            default: ''
        },
        query: {
            default: ''
        },
        width: {
            default: '100%'
        },
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        },
        defaultOptions: {
            type: Array,
            default() {
                return []
            }
        },

    },
    data() {
        return {
            model_id: '',
            modelOptions: [],
            ids: '',
        }
    },
    watch: {
        model_id: function (value, oldVal) {
            this.$emit('selected', value)
        },
        initialValue(val) {
            this.$forceUpdate()
            this.model_id = val
        },
    },
    methods: {
        getData() {
            let app = this;
            fetch(
                `/panel/get-data-full?table=${this.table}&name=${this.fieldName}&id=${this.fieldId}&${this.ids}&joins=${this.joins}&query=${this.query}`
            ).then(res => {
                res.json().then(json => {
                    app.modelOptions = json
                    app.model_id = parseInt(app.initialValue)
                    if (isNaN(app.model_id)){
                        app.model_id = app.initialValue
                    }
                    app.$forceUpdate()
                });
            });
        },
        onSearch(search, loading) {
            loading(true);
            if (search.length) {

                this.search(loading, search, this);
            } else {

                loading(false);
            }
        },
        search: _.debounce((loading, search, vm) => {
            fetch(
                `/panel/get-data-full?table=${vm.table}&name=${vm.fieldName}&id=${vm.fieldId}&joins=${vm.joins}&search=${escape(search)}`
            ).then(res => {
                res.json().then(json => (vm.modelOptions = json));
                loading(false);
            });
        }, 350),
        encodeDataToURL: (data) => {
            return Object
                .keys(data)
                .map(value => `ids[]=${encodeURIComponent(data[value])}`)
                .join('&');
        }
    },
    mounted() {

        if (this.initialValue !== null) {
            let idsArray = [];
            if (this.initialValue.hasOwnProperty('length')) {
                idsArray = JSON.parse(JSON.stringify(this.initialValue))
            } else {
                idsArray.push(this.initialValue)
            }
            this.ids = this.encodeDataToURL(idsArray)
            this.getData()
        }
    },
}
</script>

<style>
.vs__selected {
    font-size: .8571em;
}

.dropdown-menu {
    z-index:10030 !important;
}

:root {
    /* Blue */
    --blue: #3f9ce8 !important;
    --blue-light: #C8E2F8;
    --blue-medium: #9ACBF3;
    --blue-dark: #125A96;
}

/* --== Scrollbar ==-- */

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-thumb {
    background: var(--blue-medium);
    border-radius: 30px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--blue-dark);
}

::-webkit-scrollbar-track {
    background: white;
    border-radius: 0px;
}

</style>
